import { IconTextUnit, ImageView } from '../../../../components/ui';
import { Format } from '../../../../lib';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryCard as LotteryCardType } from '../../types';
import styles from './LotteryCard.module.scss';

export interface LotteryCardProps {
  lottery: LotteryCardType;
  detailPath: string;
  eventStatusLabel: (status: string) => string;
  formatCurrency: (amount: number) => string;
  formatDateCommon: (date: string, format: string) => string;
  iconCoinSmallSrc: string;
}

function LotteryCard({
  lottery,
  detailPath,
  eventStatusLabel,
  formatCurrency,
  formatDateCommon,
  iconCoinSmallSrc,
}: LotteryCardProps) {
  return (
    <a href={`${detailPath}/${lottery.id}`} className={styles.lotteryCard} data-testid='lottery-image-link'>
      <div className={styles.imageWrapper}>
        <div className={styles.itemImage}>
          <ImageView src={lottery.imageUrl} alt='画像' />
        </div>
        <div className={styles.itemStatus}>
          <img src={eventStatusLabel(lottery.status)} alt='' />
        </div>
      </div>

      <div className={styles.itemDetail}>
        <p className={`${styles.itemTitle} ${utilsStyles.textBold}`}>{lottery.lotteryTitle}</p>
        <div className={`${utilsStyles.textSmall} ${utilsStyles.mtXSmall}`}>
          <IconTextUnit unit={'/回'} text={formatCurrency(lottery.drawFee)} imgSrc={iconCoinSmallSrc} />
          {lottery.endAt && (
            <div className={`${utilsStyles.mtXSmall} ${utilsStyles.textSmall} ${styles.colorGray}`}>
              {formatDateCommon(lottery.endAt, Format.dateJa)} まで
            </div>
          )}
        </div>
      </div>
    </a>
  );
}

export default LotteryCard;
